import React from 'react';
import {connect} from 'react-redux'
import Paper from 'material-ui/Paper';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import * as colors from 'material-ui/styles/colors';

import PageBase from '../../../components/PageBase';

import gStyles from '../../../styles'

import * as actions from '../../../actions'
import SystemControllAggregateForm from './SystemControllAggregateForm'
import _ from 'lodash'

import Loading from '../../../components/Loading';

import $ from 'jquery'

import moment from 'moment'
import {clearSubmitErrors, formValueSelector, stopSubmit} from "redux-form";
import KenmeiMasterForm from "../kenmei/KenmeiMasterPage";
import * as commons from "../../../commons";



const validate = (values, kind) => {
  const errors = {}
  const requiredFields = [
      "year"
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })

  return errors
}


class SystemControllAggregatePage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      open: false
    }
  }


  componentDidMount() {

    this.props.handleInit()

    $.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
      // check for conditions and support for blob / arraybuffer response type
      if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
        return {
          // create new XMLHttpRequest
          send: function (headers, callback) {
            // setup all variables
            var xhr = new XMLHttpRequest(),
              url = options.url,
              type = options.type,
              async = options.async || true,
              // blob or arraybuffer. Default is blob
              dataType = options.responseType || "blob",
              data = options.data || null,
              username = options.username || null,
              password = options.password || null;

            xhr.addEventListener('load', function () {
              var data = {};
              data[options.dataType] = xhr.response;
              // make callback and send data
              callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
            });

            xhr.open(type, url, async, username, password);

            // setup custom headers
            for (var i in headers) {
              xhr.setRequestHeader(i, headers[i]);
            }

            xhr.responseType = dataType;
            xhr.send(data);
          },
          abort: function () {
            jqXHR.abort();
          }
        };
      }
    });

  }

  handleDownloadEnd() {
    this.setState(Object.assign(this.state, { loading: false }));
  }

  handleDownloadStart() {
    this.setState(Object.assign(this.state, { loading: true }));
  }

  handleDownload(start, end, handleFormCheck) {

    return function (values) {

      start()

      const nvl = (x) => x ? x : ''

      $.ajax({
        url: `bg/batch/aggregate`,
        dataType: "text",
        processData: false,
        error: function () {
          end()
          window.alert("エラーが発生しました。")
        },
        success: function (data) {
          end()
          window.alert("完了しました。")
        },
        type: 'GET'
      });

    }

  }


  handleConfirmOpen() {
    this.setState(Object.assign({}, this.state, {
      open: true
    }))
  }

  handleConfirmClose() {
    this.setState(Object.assign({}, this.state, {
      open: false
    }))
  }

  render() {

    const {
      form,
      handleSubHolidayClear,
      selectData,
      selectedBranchOfficeId,
      handleFormCsvCheck,
    } = this.props

    const dialogActions = [
      <FlatButton
        label="キャンセル"
        primary={true}
        onTouchTap={this.handleConfirmClose.bind(this)}
      />,
      <FlatButton
        label="削除"
        primary={true}
        keyboardFocused={true}
        onTouchTap={handleSubHolidayClear}
      />,
    ];

    return (

      <PageBase title="実行予算締め" >

        <div>

          <Paper style={{...gStyles.contentsPaper}}>
            <SystemControllAggregateForm
              initialValues={form}
              selectedBranchOfficeId={selectedBranchOfficeId}
              branchOfficeData={selectData.branchOffice}
              departmentData={selectData.department}
              onSubHolidayClear={this.handleConfirmOpen.bind(this)}
              onDownload={this.handleDownload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), handleFormCsvCheck).bind(this)}
            />
          </Paper>

        </div>

        <Loading open={this.state.loading}/>

      </PageBase>

    )
  }

}

const selector = formValueSelector(`systemControllRoumuForm`)
const mapStateToProps = (state) => ({
  form: state.systemControll.form,
  selectData: state.systemControll.selectData,
  selectedBranchOfficeId: selector(state, 'branchOfficeId')
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : () => {dispatch(actions.systemSystemControllRoumuInit())},
  handleSubHolidayClear : (form) => {
    dispatch(actions.userSystemControllSubHolidayClear(form))
  },

  handleFormCsvCheck : (values) => {

    const errors = validate(values)

    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`systemControllRoumuForm`, errors));
      return false
    }

    dispatch(clearSubmitErrors(`systemControllRoumuForm`));

    return true

  },

})

SystemControllAggregatePage = connect(
  mapStateToProps,
  mapStateToDispatch
)(SystemControllAggregatePage)

export default SystemControllAggregatePage;



// WEBPACK FOOTER //
// ./src/containers/master/systemControll/SystemControllAggregatePage.js